import { VideoContentStatusE } from "../models/enums";
import { VersionT } from "../models/models";

export const DEFAULT_PAGE_ITEMS_COUNT = 10;
export const DEFAULT_VERSION_NAME = "";
export const DATE_FORMAT = "DD/MM/YYYY";
export const ICOUNT_BASE_URL = "https://app.icount.co.il/";
export const GRANTED_FPS = 25;
export const SHOW_STOPPER_EXTRA_FRAMES = 11;
export const SHOW_STOPPER_MISSING_FRAMES = 10;
export const AUTO_DELIVERY_MAX_EXTRA_FRAMES = 8;
export const AUTO_DELIVERY_MAX_MISSING_FRAMES = 8;
export const UNCLEAR_HOUSE_NUMBER_VALUE = "Many";
export const MAX_TRANSFERRING_VIA_FTP_TIME_IN_MS = 420000;
export const DEFAULT_VERSION_DATA = {
  Id: -1,
  Name: DEFAULT_VERSION_NAME,
  FileType: undefined,
  RequiredLength: undefined,
  UploadErrorDescription: null,
  HouseNumber: null,
  isChannel5or9: null,
  useFor2Spots: null,
  AdvertisingAgencyAdId: "",
  ExpectedProjectNumber: 0,
  LengthIndex: 0,
  RejectState: null,
  BroadcasterName: null,
  is_second_slut: false,
  projectType: "VideoAd",
  FileTypeSecondSlut: null,
  FileTypeDescription: "",
  WaitingStatus: false,
  LoadingStatus: false,
  ErrorStatus: false,
  PlaybackStatus: false,
  EncodingStatus: false,
  RequiredLengthText: "",
  LengthDescription: "",
  ActualResolutionError: null,
  ThumbnailUrl: null,
  VideoWidth: 0,
  VideoHeight: 0,
  DownloadUrl: null,
  AdId: "",
};
export const NOT_TRANSLATABLE_VALUE = "%value%";
const _mobileFooterHeight = Number(getComputedStyle(document.documentElement).getPropertyValue('--mobile-footer-height')) || 50;
export const PROJECT_LIST_OFFSET_MOBILE = 180 + _mobileFooterHeight;
export const PROJECT_LIST_OFFSET_DESKTOP = 310;
export const DEFAULT_PRODUCTION_COMPANY_ID = 1185;
export const DEFAULT_POST_PRODUCTION_COMPANY_ID = 1065;
export const DEFAULT_ADVERTISER_AGENCY_ID = 1066;
// Sentinel value for the "No media company" option. No real client has id 0; the campaign payload
// builders map this to null so it persists as no FK (MediaCompanyId = NULL).
export const MEDIA_COMPANY_NONE_ID = 0;
export const DEFAULT_NO_ADVERTISER_AGENCY_ID = 1176;
export const DEFAULT_INNER_CAMPAIGN_ADVERTISER_AGENCY_ID =
  process.env.REACT_APP_DEFAULT_INNER_CAMPAIGN_AD_AGENCY_ID; // production DB value is 1683
export const EMPTY_VERSION: VersionT = {
  FileType: 1,
  // SecondHouseNumberType: 1,
  RequiredLength: undefined,
  SecondHouseNumberType: 4,
  ActualFrameCount: 0,
  ActualLength: 0,
  AdId: "",
  DesktopPlaybackUrl: "",
  DesktopVideoHeight: 0,
  DesktopVideoWidth: 0,
  DownloadAllowed: false,
  FTPSendAllowed: false,
  FileSize: 0,
  FilePath: "",
  EncodedFileId: 0,
  EncodedFileAssets: "",
  HouseNumber: "",
  Id: -1,
  ProjectId: 0,
  MobilePlaybackUrl: "",
  MobileVideoHeight: 0,
  EncodingCompleteDateTime: "",
  MobileVideoWidth: 0,
  Name: "",
  NotSuitableForBroadcast: false,
  NotSuitableForBroadcastComment: "",
  NotSuitableForBroadcastReason: 0,
  NotSuitableForBroadcastType: 0,
  PreviewDownloadUrl: "",
  ProjectType: 0,
  ShareAllowed: false,
  StatusName: VideoContentStatusE.WAITING,
  ThumbnailUrlTemplate: "",
  UploadAllowed: false,
  UploadDateTime: undefined,
  UploadErrorDescription: "",
  VideoHeight: 0,
  VideoWidth: 0,
  WideScreen: false,
  fileFormat: "",
  isChannel5or9: false,
  sponsershipHouseNumber: "",
  useFor2Spots: false,
  EncodingErrorDescription: "",
  Status: undefined,
  IsReactProject: true,
};
export const JUMBO_DELIVERY_NAME = "JumboDelivery";
export const COMMUNITY_TIME_OLD_VALUE = 2;
export const HD_WIDTH = 1920;
export const HD_HEIGHT = 1080;
export const NO_VALUE_AD_AGENCY = 1655;
export const NO_VALUE_AD_AGENCY_LABEL = "_ No Ad Agency - לא קיים משרד פרסום _";
export const NO_VALUE_AD_AGENCY_LABEL_EN = "No Ad Agency";
export const NO_VALUE_AD_AGENCY_LABEL_HE = "לא קיים משרד פרסום";
export const CAMPAIGN_NAME_SEPARATOR = "-";
export const DEFAULT_SEARCH_CATEGORY_NAME = "name";
export const DEFAULT_SEARCH_CATEGORY_NAME_MOBILE_CAMPAIGNS = "campaignNumber";
export const DEFAULT_SEARCH_CATEGORY_NAME_MOBILE_DELIVERIES = "number";
/**
 * What the DELIVERIES list's search category starts on when the user has neither a `filterType` in
 * the URL nor a remembered choice — the `number` option, which Translations renders as
 * "Delivery number" / "מספר משלוח". Same value as the MOBILE constant above and deliberately a
 * separate name: that one is read only by `getDefaultSearchCategory` (the non-autocomplete
 * Search), this one by `useCategory` on every viewport. Changing one should not silently change
 * the other.
 *
 * There is no campaigns equivalent ON PURPOSE: that page starts with nothing selected so its
 * "Search in..." placeholder is what the user sees.
 */
export const DEFAULT_DELIVERIES_SEARCH_CATEGORY = "number";
export const JUMBO_DELIVERY_ENG_USER_ID =
  "0eab15cb-9e1b-4d27-9c1d-0235e137321b";
export const JUMBO_DELIVERY_HEB_USER_ID =
  "947cad20-9086-4dd3-9c5c-b8b5196005f5";

// spec-47 — mirrors backend ExistingCampaignPolicy.WindowDays (JumboMedia.BL/SubManagers): a campaign is offered
// when it has a broadcast date within the last N days. Display only — the rule runs on the backend; this number
// appears in the "Matching campaigns … with a broadcast date in the last N days" heading. Change both together.
export const EXISTING_CAMPAIGN_WINDOW_DAYS = 30;
